import React, { useEffect, useState } from 'react';
import { ICellRendererParams } from 'ag-grid-community';
import AgileUploadRow from '@components/agile/types/AgileUploadRow';
import { ERROR_COLOR } from 'src/constants/values';
import Icon from '@amzn/meridian/icon';
import Row from '@amzn/meridian/row';
import Select, { SelectOption } from '@amzn/meridian/select';
import Tooltip from '@amzn/meridian/tooltip';
import infoKnockoutTokens from '@amzn/meridian-tokens/base/icon/info-knockout';
import { AgileMacroplanogram } from '@components/agile/types/AgileMacroplanogramTypes';
import { AssortmentEntryAction } from '@graphql/generated/graphql';

const AtZoneSelectionCellRenderer = (params: {
  node: ICellRendererParams;
  setRowData: (value: AgileUploadRow[]) => void;
  rowData: AgileUploadRow[];
  setRecommendationFlag: (value: boolean) => void;
  listOfMacroplanogram: AgileMacroplanogram[] | undefined;
}) => {
  const { node, setRowData, rowData, setRecommendationFlag, listOfMacroplanogram } = params;
  const data: AgileUploadRow = node.data as AgileUploadRow;
  const [selectedMacroplanogram, setSelectedMacroplanogram] = useState<string>(data.macroplanogramId as string);
  const [errorFlag, setErrorFlag] = useState(selectedMacroplanogram === '');
  const onClick = (macroplanogramId: string) => {
    setSelectedMacroplanogram(macroplanogramId);
    const tempData = [...rowData];
    const rowIndex = tempData.findIndex((item) => item.index === data.index);
    if (tempData[rowIndex].macroplanogramId !== macroplanogramId) {
      setRecommendationFlag(false);
    }
    tempData[rowIndex].macroplanogramId = macroplanogramId;
    setRowData(tempData);
    setErrorFlag(false);
  };

  useEffect(() => {
    const isZonePresentInStore = listOfMacroplanogram?.some(
      ({ entryId: objValue }) => objValue === (data.macroplanogramId as string),
    );
    if (!isZonePresentInStore || data.macroplanogramId === '') {
      setRecommendationFlag(false);
      setErrorFlag(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.macroplanogramId]);
  return (
    <Row spacing="none" spacingInset="none" maxWidth="50">
      {data.action?.action === AssortmentEntryAction.Remove ? (
        <span>
          {' '}
          {
            listOfMacroplanogram?.find((macroPlanogram) => macroPlanogram.entryId === selectedMacroplanogram)
              ?.macroplanogramName
          }
        </span>
      ) : (
        <Select value={selectedMacroplanogram} onChange={onClick} width={130} error={errorFlag}>
          {listOfMacroplanogram?.map((macroplanogram) => (
            <SelectOption
              value={macroplanogram.entryId}
              label={macroplanogram?.macroplanogramName ?? 'Select zone'}
              key={macroplanogram.entryId}
            />
          ))}
        </Select>
      )}
      {errorFlag ? (
        <Tooltip position="end" title="Please select a zone" id="myTooltip">
          <Icon className={ERROR_COLOR} tokens={infoKnockoutTokens} />
        </Tooltip>
      ) : null}
    </Row>
  );
};

export default AtZoneSelectionCellRenderer;
